module.exports = __webpack_public_path__ + "img/battletanks-preview.67d439a8.png";